<template>
  <v-skeleton-loader v-if="previewIsLoading" type="paragraph@5" />

  <div v-else-if="invitationPreview">
    <!-- Fixed rather than 70vh so only the iframe's own scrollbar shows: AppModal's card tops
         out at 720px and its body is the scrollable part, so anything taller than the space
         left by the header and footer adds a second scrollbar. 490px was found empirically,
         500px still overflowed. A height driven by the body would be better, but percentages
         resolve against an indefinite height here, so they collapse the iframe instead. -->
    <iframe :srcdoc="invitationPreview"
            title="Invitation Preview"
            style="width: 100%; height: 490px; border: 0"
    />
  </div>
</template>

<script>
import { toast } from '@/common/utils/toast'
import groupsService from '@/services/groups.service'

export default {
  name: 'MemberInvitationPreview',
  props: {
    memberForm: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      invitationPreview: null,
      previewIsLoading: false,
    }
  },
  async mounted () {
    this.previewIsLoading = true
    const {
      firstName,
      lastName,
      email,
      locale,
      customInvitationMessage: customMessage,
    } = this.memberForm

    try {
      const previewResponse = await groupsService.getPreviewInvitation(this.$route.params.mnemo, {
        firstName,
        lastName,
        email,
        locale,
        customMessage,
      })

      this.invitationPreview = previewResponse.data.html
    } catch (error) {
      console.error(error)

      toast.error(this.$t('project.members.MemberInvitationPreview.getInvitationPreviewError'))
    } finally {
      this.previewIsLoading = false
    }
  },
}
</script>
